import React, { useState, useEffect } from 'react';
import ECharts from 'echarts-for-react';
import { getChartUnit } from 'Util';

const InvestStrg = ({ data, title }) => {
  
  const [options, setOptions] = useState();

  useEffect(() => {
    if (data) {
      const color = ['#f15050', '#3582f5', '#3a3a3a'];

      const option = {
        animation: false,
        legend: {
          textStyle: { fontSize: 10 },
          itemStyle: { opacity: 0 },
          data: [{
            name: title[0],
            lineStyle: { color: color[0] },
          }, {
            name: title[1],
            lineStyle: { color: color[1] },
          }, {
            name: title[2],
            lineStyle: { color: color[2] },
          }]
        },
        grid: {
          top: 30,
          right: 10,
          bottom: 10,
          left: 10,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          position: 'bottom',
          axisLine: { onZero: false },
          axisTick: { show: false },
          splitArea: { show: true },
          axisLabel: {
            interval: Math.round(data.x.length/6),
            showMinLabel: true,
            showMaxLabel: true,
            fontSize: 10,
            formatter: (value) => {
              const tmp = value.split('.')
              return tmp[0].substring(2,4) + '.' + tmp[1]
            }
          },
          data: data.x
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              fontSize: 10,
            },
            min: -6,
            max: 6,
            minInterval: 2
          },
          {
            type: 'value',
            axisLabel: {
              fontSize: 10,
            },
            min: function (value) {
              var cap = value.max - value.min;
              const unit = getChartUnit(cap);
              if (value.min % unit === 0) {
                return value.min;
              } else {
                return value.min - (value.min % unit);
              }
            },
          }
        ],
        series: [
          {
            name: title[0],
            data: data.y1,
            type: 'bar',
            itemStyle: { color: color[0] },
            barGap: '-100%',
            barCategoryGap: '0%'
          },
          {
            name: title[1],
            data: data.y2,
            type: 'bar',
            itemStyle: { color: color[1] },
            barGap: '-100%',
            barCategoryGap: '0%'
          },
          {
            name: title[2],
            data: data.y3,
            yAxisIndex: 1,
            type: 'line',
            symbol: 'none',
            itemStyle: { color: color[2] },
            lineStyle: { color: color[2], width: 1 },
          }
        ],
      }
      setOptions(option);
    }
  }, [data, title]);

	return (
    <div style={{width: '100%', height: '200px'}}>
      { options && 
        <ECharts option={options} style={{ width: '100%', height: '100%' }} />
      }
    </div>
  );
}

export default InvestStrg;
